import React, { useEffect } from 'react'
import axios from 'axios';

import './HomeVideo.css'

export default function HomeVideo() {
    const [videoList, setVideoList] = React.useState([]);

    useEffect(() => {
        axios.get("https://api.360ep.cn/api/video/?pagesize=4").then(res => {
            setVideoList(res.data.data);
        });
    }, []);

    return (
        <div className="home-video">
            <div className="top-title">
                视频专访
            </div>
            <div className="video-list">

                {
                    videoList.map((item, index) => {
                        return (
                            <div className='video-item' key={index}>
                                <a href={item.Video} target="_blank" rel="noopener noreferrer">
                                    <p>{item.Title}</p>
                                    <div className="video-info">
                                        <img src={item.Thumb} alt={item.Title}/>
                                        <div className='video-describe'>
                                            <span>{item.Introduce ? item.Introduce : item.Title}</span>
                                            <div className='video-hist'>({item.Hits})</div>
                                        </div>
                                        
                                    </div>                                    
                                </a>
                            </div>)
                    })}
            </div>
        </div>
    )
}
